<template>
  <div v-show="loading" class="progress-bar">
    <v-progress-linear
      color="light-blue"
      height="8"
      value="10"
      :indeterminate="true"
      striped
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
  }
};
</script>

<style lang="scss" scoped>
.fullview {
  width: 100%;
  height: 100vh;
  background-color: #f5f7fc;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  opacity: 0.5;
}
// .progress-bar {
//   width: 100%;
//   height: auto;
//   box-shadow: 0px 0px 5px rgba(#000, 0.1);
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: 100;
// }
</style>